export const getToken = function () {
  const storagedUser = localStorage.getItem('@App:user');
  const user = JSON.parse(storagedUser || '');

  const token = user ? user.token : '';
  return token;
};
